import { iEnv } from './iEnv.interface';

export const environment: iEnv = {
  info: 'dev',
  backEndpoint: 'https://gem389bcd4.execute-api.eu-south-2.amazonaws.com/',
  mainTitle: 'Laborys - Dev',
  defaultEmail: 'erp.gang.development@gmail.com',
  stripePublishableKey:
    'pk_test_51Rem9xCTB5XfPjxaxXS90tiZPoHdeQpQkKdVn8vKzDnkpcfoAVRKdAi8kAUknhDhsCvf3SyeCCXs11xNteutq60900bIRDO7IL',
};
